import data from '../redux/fe-data/mock';
import { isTestEnvironment } from '../util/environment';


const userData = data.trial_responder_added_contact_method;
// const userData = data.trial_owner_show_onboarding_experiment;

export default function () {
  if (isTestEnvironment()) return this.get('/fe-data', this.passthrough);

  return this.get('/fe-data', () => [
    200,
    { 'Content-Type': 'application/json' },
    JSON.stringify(userData)
  ]);
}
